import * as React from "react"
import { SVGProps } from "react"
const FastRequestIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg 
    className="w-[14px] h-[14px]" 
    fill="none" 
    stroke="white" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    viewBox="0 0 24 24" 
    {...props}
  > 
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /> 
  </svg>
)
export default FastRequestIcon